var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-button"},[_c('v-btn',{attrs:{"fab":"","outline":"","color":_vm.color},on:{"click":_vm.click}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab640d68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/card/buttoncard.vue
// module id = null
// module chunks = 